<ng-container *ngIf="isBrowser">
    <ckeditor
        [config]="config"
        [data]="value"
        [editor]="Editor"
        (change)="onChange($event)">
    </ckeditor>
</ng-container>
